export default {
  FETCH_TIER_ACTIVITIES_REQUEST: "FETCH_TIER_ACTIVITIES_REQUEST",
  FETCH_TIER_ACTIVITIES_FAILED: "FETCH_TIER_ACTIVITIES_FAILED",
  FETCH_TIER_ACTIVITIES_SUCCESS: "FETCH_TIER_ACTIVITIES_SUCCESS",

  FETCH_ACTION_ACTIVITIES_REQUEST: "FETCH_ACTION_ACTIVITIES_REQUEST",
  FETCH_ACTION_ACTIVITIES_FAILED: "FETCH_ACTION_ACTIVITIES_FAILED",
  FETCH_ACTION_ACTIVITIES_SUCCESS: "FETCH_ACTION_ACTIVITIES_SUCCESS"
};
